var _ = require('lodash');
var angular = require('angular/index');
require('../core');

angular.module('utility-ng-interface').run(function (Interface, $injector) {
  Interface.type('ngArray', {
    defaultValue: function () {
      return [];
    },
    convertToSource: function convertBackToArray(syncProp, req) {
      return _.map(
        syncProp,
        function (obj) {
          var fn = this[this.activeMethod];
          return fn.call(this, req.typeDef, obj);
        },
        this
      );
    },
    convertToSync: function (sourceProp, req, source, sync, isRequired) {
      if (!isRequired && _.isUndefined(sourceProp)) {
        return sourceProp;
      }

      var Builder = _.isString(req.typeDef) ? $injector.get(req.typeDef) : req.typeDef;

      return _.map(sourceProp, function (obj, key) {
        return new Builder(obj);
      });
    },
    isOfType: function verifyTypeFactory(val) {
      return !_.isNull(val) && !_.isUndefined(val) && _.isArray(val);
    }
  }).type('ngObject', {
    defaultValue: function () {
      return {};
    },
    convertToSource: function convertBackToArray(syncProp, req) {
      return _.zipObject(
        _.keys(syncProp),
        _.map(
          syncProp,
          function (obj) {
            var fn = this[this.activeMethod];
            return fn.call(this, req.typeDef, obj);
          },
          this
        )
      );
    },
    convertToSync: function (sourceProp, req, source, sync, isRequired) {
      if (!isRequired && _.isUndefined(sourceProp)) {
        return sourceProp;
      }

      var Builder = _.isString(req.typeDef) ? $injector.get(req.typeDef) : req.typeDef;

      _.each(sourceProp, function (obj, key, o) {
        o[key] = Builder ? new Builder(obj) : obj;
      });

      return sourceProp;
    },
    isOfType: function verifyTypeFactory(val) {
      return !_.isNull(val) && !_.isUndefined(val) && _.isObject(val);
    }
  });
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/types/collections.js